// This function return selected revenue centers uuids based on menus assigned to it.
// Revenue center will be selected when all his menus are selected
export const getSelectedRevenueCentersUuids = (
  revenueCentersAndMenus,
  menuUuids
) => {
  return (
    revenueCentersAndMenus?.reduce((acc, cur) => {
      const { menus, uuid } = cur

      // return assigned menus per revenue center uuids
      const menusUuids = menus?.map(({ uuid }) => uuid)

      // check if all assigned menus per revenue center is selected
      const isAllMenusChecked = menusUuids?.every((uuid) => {
        return menuUuids?.includes(uuid)
      })

      if (isAllMenusChecked) {
        return [...acc, uuid]
      }
      return acc
    }, []) ?? []
  )
}
